import React from 'react';

import { Body, Container, Description, Instructions } from './RiskAssessmentResultModal.styled';
import { Modal } from 'components/v2/Modal/Modal';

import { RiskAssessmentResultModalProps } from './RiskAssessmentResultModal.types';

export const RiskAssessmentResultModal = ({ isOpen, onClose }: RiskAssessmentResultModalProps) => {
  return (
    <Modal title="Thank you for your submission" open={isOpen} onCancel={onClose} maxWidth={580}>
      <Container>
        <Body>
          <Description>
            Your assessment helps us understand when you should come in for your initial pregnancy
            appointment.
          </Description>
          <Instructions>
            If you have already booked your first pregnancy appointment, there is nothing you need
            to do. Otherwise, please schedule a pregnancy confirmation visit with your OBGYN
            provider.
          </Instructions>
        </Body>
      </Container>
    </Modal>
  );
};
